import { StaffLink } from './Staff'
import { Group } from './Group'
import { Section, SectionGroup } from './Section'
import { StaffLevel } from './StaffLevel'

export interface Accessibility {
    id: number
    type: AccessibilityType
    start: string
    end: string
}

export interface DaycareOpening {
    monOpen: Date | null
    monClose: Date | null
    monBreakStart: Date | null
    monBreakEnd: Date | null
    tueOpen: Date | null
    tueClose: Date | null
    tueBreakStart: Date | null
    tueBreakEnd: Date | null
    wedOpen: Date | null
    wedClose: Date | null
    wedBreakStart: Date | null
    wedBreakEnd: Date | null
    thuOpen: Date | null
    thuClose: Date | null
    thuBreakStart: Date | null
    thuBreakEnd: Date | null
    friOpen: Date | null
    friClose: Date | null
    friBreakStart: Date | null
    friBreakEnd: Date | null
    satOpen: Date | null
    satClose: Date | null
    satBreakStart: Date | null
    satBreakEnd: Date | null
    sunOpen: Date | null
    sunClose: Date | null
    sunBreakStart: Date | null
    sunBreakEnd: Date | null
}

export interface Daycare {
    id: number
    active?: boolean
    staffAccess?: boolean
    type: DaycareType
    name: string
    manager: string
    email: string
    phone: string
    address: string
    city: string
    zip: string
    country: string
    bookMin: number
    bookWeeklyLimit: number
    merger: boolean
    bookRange: BookRange
    created?: Date
    updated?: Date
    timezone?: string
    accessibility?: Array<Accessibility>
    opening: DaycareOpening
    staffLink: StaffLink | null
    trusteeWrite: boolean
    autoLink?: string
    autoLinkEnable?: boolean
    internalAutoLink?: string
    internalAutoLinkEnable?: boolean
    externalAutoLink?: string
    externalAutoLinkEnable?: boolean
    activeAlert: boolean
    alertRange: AlertRange
    alertComment: string
    validityEnd?: Date
    groups?: Group[]
    sections?: Section[]
    sectionsGroups?: SectionGroup[]
    levels?: StaffLevel[]
    staffCount?: number
    mailSignature: string
    expirationDuration: ExpirationDuration
    newsAccess?: boolean
    limitByWeek: number
    limitOfSlot: number
    exceedLimit: boolean
    suggestAccess?: boolean
    taskNoteAccess?: boolean
    colors?: DaycareColors
    logoBase64Data?: string
    predefinedMessages?: Array<DaycarePredefinedMessage>
    releaseParameters?: DaycareReleaseParameters
    haveDaycareGroup?: boolean
    mealAccess?: boolean
    annuaireId?: string
}

export interface DaycarePredefinedMessage {
    type: DaycarePredefinedMessageType
    message: string
}

export interface DaycareReleaseParameters {
    releaseActivation: ReleaseActivation
    releaseWeekCountBefore: number
    releaseDayCountBefore: number
    releaseDay: number
    releaseHour: Date
}

export enum ReleaseActivation {
    releaseDeactive = 'release_deactive',
    releaseDay = 'release_day',
    releaseWeek = 'release_week'
}

export interface DaycareColors {
    daycareDark: string
    daycareMain: string
    daycareLight: string
    daycareExtraLight: string
    parentDark: string
    parentMain: string
    parentLight: string
    parentExtraLight: string
}

export enum AccessibilityType {
    arrival = 'arrival',
    departure = 'departure'
}

export enum BookRange {
    range15 = 'range_15',
    range30 = 'range_30',
    range60 = 'range_60'
}

export enum DaycareType {
    daycare = 'daycare',
    nursery = 'nursery',
    toyLibrary = 'toy_library',
    multiHome = 'multi_home',
    recreationCenter = 'recreation_center',
    playCenter = 'play_center',
    microDaycare = 'micro_daycare',
    rpe = 'rpe',
    laep = 'laep',
    other = 'other'
}

export enum AlertRange {
    alert24 = 'alert_24',
    alert48 = 'alert_48',
    alert72 = 'alert_72',
    alert7d = 'alert_7d',
    alert14d = 'alert_14d'
}

export enum ExpirationDuration {
    expiration0 = 'expiration_0',
    expiration1 = 'expiration_1',
    expiration4 = 'expiration_4',
    expiration12 = 'expiration_12',
    expiration18 = 'expiration_18',
    expiration24 = 'expiration_24',
    expiration48 = 'expiration_48',
    expiration72 = 'expiration_72',
    expiration168 = 'expiration_168'
}

export enum DaycarePredefinedMessageType {
    acceptRegularRequest = 'acceptRegularRequest',
    rejectRegularRequest = 'rejectRegularRequest',
    cancelOccasionalSlot = 'cancelOccasionalSlot',
    acceptRequestSlot = 'acceptRequestSlot',
    rejectRequestSlot = 'rejectRequestSlot',
    declareAbsenceRegularSlot = 'declareAbsenceRegularSlot'
}
